import Vue from 'vue'
import { StripePlugin } from '@vue-stripe/vue-stripe'
import Config from '@/config.json'

const options = {
  pk: Config.VUE_APP_STRIPE,
  stripeAccount: Config.VUE_APP_STRIPE_ACC,
  apiVersion: '1.0',
  locale: 'MY'
}
Vue.use(StripePlugin, options)
